// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"225":"93cb933d","418":"21bd43e4"}[chunkId] + ".js";
};